<template>
  <nav class="shadow-none navbar navbar-main navbar-expand-lg border-radius-xl" v-bind="$attrs" id="navbarBlur"
    data-scroll="true">
    <div class="px-3 py-1 container-fluid">
      <breadcrumbs :currentPage="currentRouteName" :textWhite="textWhite" />

      <div class="mt-2 collapse navbar-collapse mt-sm-0 me-md-0 me-sm-4"
        :class="this.$store.state.common.isRTL ? 'px-0' : 'me-sm-4'" id="navbar">
        <div class="pe-md-3 d-flex align-items-center"
          :class="this.$store.state.common.isRTL ? 'me-md-auto' : 'ms-md-auto'">
          <!-- <div class="input-group">
            <span class="input-group-text text-body"
              ><i class="fas fa-search" aria-hidden="true"></i
            ></span>
            <input
              type="text"
              class="form-control"
              :placeholder="
                this.$store.state.common.isRTL ? 'أكتب هنا...' : 'Type here...'
              "
            />
          </div> -->
        </div>
        <ul class="navbar-nav justify-content-end">
          <!-- ✅ User Dropdown -->
          <li class="nav-item dropdown d-flex align-items-center">
            <a href="#" class="nav-link dropdown-toggle font-weight-bold" :class="textWhite ? textWhite : 'text-body'"
              id="userDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              <i class="fa fa-user" :class="this.$store.state.common.isRTL ? 'ms-sm-2' : 'me-sm-1'"></i>
              <span v-if="this.$store.state.common.isRTL" class="d-sm-inline d-none">
                الحساب
              </span>
              <span v-else class="d-sm-inline d-none"> Account </span>
            </a>
            <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
              <li>
                <a class="dropdown-item" href="#" @click="openChangePasswordModal">
                  <i class="fa fa-key me-2"></i> Change Password
                </a>
              </li>
              <li>
                <a class="dropdown-item" href="#" @click="onSignOut">
                  <i class="fa fa-sign-out-alt me-2"></i> Sign Out
                </a>
              </li>
            </ul>
          </li>

          <!-- Sidebar toggle (mobile) -->
          <li class="nav-item d-xl-none ps-3 d-flex align-items-center">
            <a href="#" @click="toggleSidebar" class="p-0 nav-link text-body" id="iconNavbarSidenav">
              <div class="sidenav-toggler-inner">
                <i class="sidenav-toggler-line"></i>
                <i class="sidenav-toggler-line"></i>
                <i class="sidenav-toggler-line"></i>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>

    <!-- ✅ Change Password Modal -->
    <div class="modal fade" id="changePasswordModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Change Password</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body">
            <div class="mb-3">
              <label class="form-label">Current Password</label>
              <input type="password" class="form-control" v-model="form.current_password" />
            </div>
            <div class="mb-3">
              <label class="form-label">New Password</label>
              <input type="password" class="form-control" v-model="form.new_password" />
            </div>
            <div class="mb-3">
              <label class="form-label">Confirm Password</label>
              <input type="password" class="form-control" v-model="form.confirm_password" />
            </div>

            <div v-if="error" class="alert alert-danger">{{ error }}</div>
            <div v-if="success" class="alert alert-success-green">{{ success }}</div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cancel
            </button>
            <button type="button" class="btn btn-primary" @click="submitChangePassword">
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>
<style scoped>
.alert-success-green {
  background-image: linear-gradient(310deg, #4caf50 0%, #2e7d32 100%);
  color: #fff;
}
</style>
<script>
import Breadcrumbs from "../Breadcrumbs.vue";
import { mapMutations, mapActions } from "vuex";
import router from "../../router/index";
import bootstrap from "bootstrap/dist/js/bootstrap";
import API from "../../api/api";
import { authHeader } from "../../helpers/authHeader";

export default {
  name: "navbar",
  props: ["minNav", "textWhite"],
  data() {
    return {
      showMenu: false,
      router,
      form: {
        current_password: "",
        new_password: "",
        confirm_password: "",
      },
      error: "",
      success: "",
    };
  },
  methods: {
    ...mapMutations("common", ["navbarMinimize", "toggleConfigurator"]),
    ...mapActions("common", ["toggleSidebarColor"]),

    toggleSidebar() {
      this.toggleSidebarColor("bg-white");
      this.navbarMinimize();
    },
    onSignOut() {
      localStorage.removeItem("token");
      localStorage.removeItem("email");
      this.router.push("/sign-in");
    },
    openChangePasswordModal() {
      this.error = "";
      this.success = "";
      this.form = {
        current_password: "",
        new_password: "",
        confirm_password: "",
      };
      const modal = new bootstrap.Modal(
        document.getElementById("changePasswordModal")
      );
      modal.show();
    },
    async submitChangePassword() {
      this.error = "";
      this.success = "";

      if (this.form.new_password !== this.form.confirm_password) {
        this.error = "New password and confirm password do not match.";
        return;
      }

      const payload = {
        current_password: this.form.current_password,
        new_password: this.form.new_password,
      };

      await API.post("change-password", payload, { headers: authHeader() })
        .then((res) => {
          if (res.data.status) {
            this.success = res.data.message || "Password changed successfully.";
            setTimeout(() => {
              const modal = bootstrap.Modal.getInstance(
                document.getElementById("changePasswordModal")
              );
              modal.hide();
            }, 1500);
          } else {
            this.error = res.data.message || "Failed to change password.";
          }
        })
        .catch((err) => {
          this.error = err.response?.data?.message || "Failed to change password.";
          console.log("ERROR", err);
        });
    }

  },
  components: {
    Breadcrumbs,
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
  },
  updated() {
    const navbar = document.getElementById("navbarBlur");
    window.addEventListener("scroll", () => {
      if (window.scrollY > 10 && this.$store.state.common.isNavFixed) {
        navbar.classList.add("blur", "position-sticky", "shadow-blur");
      } else {
        navbar.classList.remove("blur", "position-sticky", "shadow-blur");
      }
    });
  },
};
</script>
